import React from 'react';
import { Typography, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

// --- Styled Layout ---

const LabelContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: theme.spacing(0.8),
  width: '100%',
}));

const StyledTypography = styled(Typography, {
  shouldForwardProp: (prop) => !['fontWeight', 'color'].includes(prop),
})(({ fontWeight, color }) => ({
  fontFamily: 'Lato',
  fontSize: 13,
  fontWeight: fontWeight || 'normal',
  color: color || '#757575',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: 'block',
  flexGrow: 1,
}));

const IconSquare = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 20,
  height: 16,
  borderRadius: 4,
  marginLeft: theme.spacing(0.5),
}));

const GreenSquare = styled(IconSquare)({
  backgroundColor: '#f3fdf4',
  '& .MuiSvgIcon-root': {
    fontSize: 12,
    color: '#26882a',
  },
});

const GreySquare = styled(IconSquare)(({ theme }) => ({
  backgroundColor: '#f7f7f7',
  '& .MuiSvgIcon-root': {
    fontSize: 12,
    color: theme.palette.action.disabled,
  },
}));

const Label = (props) => {
  const { 
    isEditIcon = false, 
    module = "", 
    label, 
    labelClassName = '', 
    fontWeight, 
    color,
    variant="body2"
  } = props;

  return (
    <LabelContainer className={labelClassName}>
      <StyledTypography variant={variant} fontWeight={fontWeight} color={color}>
        {label}
      </StyledTypography>

      {module === "claim_beta" && (
        <React.Fragment>
          {isEditIcon ? (
            <GreenSquare>
              <EditOutlinedIcon/>
            </GreenSquare>
          ) : (
            <GreySquare>
              <LockOutlinedIcon/>
            </GreySquare>
          )}
        </React.Fragment>
      )}
    </LabelContainer>
  );
};

export default Label;